module.exports = __webpack_public_path__ + "images/shop/favicon-kfzteile-com/apple-touch-icon.png";